// import JSEncrypt from 'jsencrypt';

import { getPublicKey } from '@/utils/constants';

let JSEncrypt: any = null;

export const getEncryptValue = async (beforeParams: any, isV3 = true) => {
  const params: any = { ...beforeParams };
  const { password, samepassword } = params;
  const timeStamp = +new Date().getTime();
  const data = password + ':' + timeStamp;
  if (!JSEncrypt) {
    JSEncrypt = (await import('jsencrypt')).default;
  }
  // 新建JSEncrypt对象
  const encrypt = new JSEncrypt();
  // 设置公钥
  encrypt.setPublicKey(getPublicKey());
  // 加密数据
  const realPassword: any = {
    encrypt_password: encrypt.encrypt(data),
    encrypt_timestamp: timeStamp.toString(),
  };
  if (samepassword) {
    realPassword.encrypt_samepassword = realPassword.encrypt_password;
  }
  delete params.password;
  delete params.samepassword;
  return { ...params, ...realPassword };
};
